// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// WorkItemPriority — source: shared/config/sf_priorities.config.json

export const WORK_ITEM_PRIORITY_VALUES = [0, 1, 2, 3] as const;
export type WorkItemPriority = (typeof WORK_ITEM_PRIORITY_VALUES)[number];

export const workItemPriorityBadgeClass: Record<number, string> = {
  0: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  1: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  2: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  3: "bg-muted text-muted-foreground",
};

export const workItemPriorityColor: Record<number, string> = {
  0: "#EF4444",
  1: "#F59E0B",
  2: "#3B82F6",
  3: "#6B7280",
};

